// LifeIndividuals.jsx (fix)
import React from "react";
import { useTranslation } from "react-i18next";
import "../Style/lifeIndividuals.css";

const NS = "lifeIndividualsPage";

export default function LifeIndividuals() {
  const { t } = useTranslation(NS);

  const seo = t("seo", { returnObjects: true });
  const hero = t("hero", { returnObjects: true });
  const sections = t("sections", { returnObjects: true });
  const closing = t("closing", { returnObjects: true });

  const safeSections = Array.isArray(sections) ? sections : [];
  const heroSubtitle = Array.isArray(hero?.subtitle) ? hero.subtitle : [];
  const closingParagraphs = Array.isArray(closing?.paragraphs) ? closing.paragraphs : [];

  return (
    <main className="lifeX-page" aria-label={seo?.ariaLabel || "Life for Individuals"}>
      <header className="lifeX-hero">
        <div className="lifeX-container">
          <div className="lifeX-hero__grid">
            <div className="lifeX-hero__copy">
              <h1 className="lifeX-h1">{hero?.title}</h1>

              <div className="lifeX-prose lifeX-prose--hero">
                {heroSubtitle.map((p, i) => (
                  <p key={i} className="lifeX-p lifeX-p--hero">{p}</p>
                ))}
              </div>

              <div className="lifeX-ctaRow" role="group" aria-label="Hero actions">
                <a className="lifeX-btn lifeX-btn--primary" href={hero?.primaryCta?.href || "#"}>
                  {hero?.primaryCta?.label}
                </a>
                <a className="lifeX-btn lifeX-btn--ghost" href={hero?.secondaryCta?.href || "#"}>
                  {hero?.secondaryCta?.label}
                </a>
              </div>
            </div>

            <div className="lifeX-figure lifeX-figure--hero">
              <div className="lifeX-illustration" role="img" aria-label={hero?.illustrationSuggestion || "Illustration"} />
              <p className="lifeX-caption"><em>{hero?.illustrationSuggestion}</em></p>
            </div>
          </div>
        </div>
      </header>

      {safeSections.map((s, idx) => (
        <section key={s.id} id={s.id} className="lifeX-section" aria-labelledby={`${s.id}-title`}>
          <div className="lifeX-container">
            <div className={`lifeX-split ${idx % 2 === 1 ? "lifeX-split--reverse" : ""}`}>
              <div className="lifeX-copy">
                <h2 className="lifeX-h2" id={`${s.id}-title`}>{s.title}</h2>
                <div className="lifeX-prose">
                  {(Array.isArray(s.paragraphs) ? s.paragraphs : []).map((p, i) => (
                    <p key={i} className="lifeX-p">{p}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      <section id="closing" className="lifeX-section lifeX-section--cta" aria-labelledby="closing-title">
        <div className="lifeX-container">
          <div className="lifeX-ctaCard">
            <div className="lifeX-ctaCard__copy">
              <h2 className="lifeX-h2" id="closing-title">{closing?.title}</h2>
              <div className="lifeX-prose">
                {closingParagraphs.map((p, i) => (
                  <p key={i} className="lifeX-p">{p}</p>
                ))}
              </div>

              <div className="lifeX-ctaRow" role="group" aria-label="Closing actions">
                <a className="lifeX-btn lifeX-btn--primary" href={closing?.primaryCta?.href || "#"}>
                  {closing?.primaryCta?.label}
                </a>
                <a className="lifeX-btn lifeX-btn--ghost" href={closing?.secondaryCta?.href || "#"}>
                  {closing?.secondaryCta?.label}
                </a>
              </div>
            </div>

            <div className="lifeX-figure lifeX-figure--cta">
              {/* <div className="lifeX-illustration" role="img" aria-label={closing?.illustrationSuggestion || "Illustration"} />
              <p className="lifeX-caption"><em>{closing?.illustrationSuggestion}</em></p> */}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
